module.exports = __webpack_public_path__ + "img/mockup-4.5684870f.png";